import { useMemo } from "react"
import { COLOR } from "../data/variables"

type Axis = {
  xType: string
  yAxisTitle: string
  xFormat?: string
}

type Series = {
  name: string
  data: number[]
}

type UseHighcharts = {
  zoomable?: boolean
  type?: string
  title: string
  axis: Axis
  tooltip?: string,
  series?: Series[],
  subtitle?: string
  height?: number
  events?: any
}

export const useHighcharts = ({
  zoomable = true, type = 'spline', title, axis, tooltip, series = [], subtitle, height,
  events
}: UseHighcharts) => {
  const options = useMemo(() => {
    const chartOption = {
      chart: {
        type,
        height: height ?? 250,
      },
      title: {
        text: title ?? '',
        align: 'center'
      },
      xAxis: {
        type: axis?.xType,
        labels: {
          overflow: 'justify',
          format: axis.xFormat ?? undefined
        }
      },
      yAxis: {
        title: {
          text: axis?.yAxisTitle ?? ''
        },
        minorGridLineWidth: 1,
        gridLineWidth: 0,
        alternateGridColor: null,
      },
      plotOptions: {
        spline: {
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 2
            }
          },
          marker: {
            enabled: false
          }
        },
        color: [COLOR.RED_70, COLOR.BLUE_70]
      },
      series,
      navigation: {
        menuItemStyle: {
            fontSize: '10px'
        }
      }
    }

    if (subtitle) {
      chartOption.subtitle = {
        text: subtitle
      }
    }

    if (zoomable) {
      chartOption.chart.zooming = { type: 'x' }
      chartOption.chart.scrollablePlotArea = {
        minWidth: 600,
        scrollPositionX: 1
      }
    }
    if (tooltip) {
      chartOption.tooltip = {
        valueSuffix: tooltip
      }
    }

    if (events) {
      chartOption.chart.events = events
    }

    return chartOption
  }, [zoomable, type, title, tooltip, axis, series, subtitle, height, events])

  return {
    options
  }
}
